import {
  getGetAnalyticFirmAssociatesQueryKey,
  useGetAnalyticFirmAssociates,
  useGetCurrentEndUser,
} from '@utility-nyc/react-query-sdk';

const useAnalyticFirmAssociates = () => {
  const { data: currentUser } = useGetCurrentEndUser();
  const endUser = currentUser?.data;

  return useGetAnalyticFirmAssociates({
    query: {
      enabled: Boolean(endUser?.analyticsFirm?.id),
      queryKey: [
        ...getGetAnalyticFirmAssociatesQueryKey(),
        endUser?.id,
        endUser?.analyticsFirm?.id,
      ],
    },
  });
};

export { useAnalyticFirmAssociates };
